import {Dropdown} from "react-bootstrap";
import {useMe} from "../../hooks/useGetUser";
import Loader from "../components/shared/Loader";
import frFlag from "../../images/FrenchFlag.svg";
import enFlag from "../../images/EnglishFlag.svg";
import {useEffect, useState} from "react";
import ListBlockedUsersModal from "../components/AcountSettings/ListBlocsModal";
import {useUpdateTechnician} from "../../hooks/useUpdateUser";
import SuppModal from "../components/shared/suppAccountModal";
import {useTranslation} from "react-i18next";

const AccountSettingPage = () => {
  const {t, i18n} = useTranslation();
  const language = i18n.resolvedLanguage?.startsWith("en") ? "en" : "fr";
  const {data, isLoading: isMeLoading} = useMe();
  const [openModal, setOpenModal] = useState(false);
  const [openSuppModal, setOpenSuppModal] = useState(false);
  const {onUpdateSettings} = useUpdateTechnician();
  const [localSettings, setLocalSettings] = useState({
    reminderNotifs: data?.reminderNotifs,
    messageNotifs: data?.messageNotifs,
    interventionNotifs: data?.interventionNotifs,
    mailNotifs: data?.mailNotifs,
    offerNotifs: data?.offerNotifs,
    smsNotifs: data?.smsNotifs,
  });
  const [pendingSetting, setPendingSetting] = useState(null);

  useEffect(() => {
    if (data) {
      setLocalSettings({
        reminderNotifs: data?.reminderNotifs,
        messageNotifs: data?.messageNotifs,
        interventionNotifs: data?.interventionNotifs,
        mailNotifs: data?.mailNotifs,
        offerNotifs: data?.offerNotifs,
        smsNotifs: data?.smsNotifs,
      });
    }
  }, [data]);

  const handleToggle = async (key) => {
    if (pendingSetting) return;
    const previousValue = Boolean(localSettings[key]);
    const nextValue = !previousValue;
    setLocalSettings((prev) => ({...prev, [key]: nextValue}));
    setPendingSetting(key);
    try {
      await onUpdateSettings({id: data.id, body: {[key]: nextValue}});
    } catch (_) {
      setLocalSettings((prev) => ({...prev, [key]: previousValue}));
    } finally {
      setPendingSetting(null);
    }
  };

  const handleLanguageChange = (nextLanguage) => {
    i18n.changeLanguage(nextLanguage);
  };

  if (isMeLoading) {
    return <Loader />;
  }

  return (
    <>
      <ListBlockedUsersModal
        show={openModal}
        handleClose={setOpenModal}
        blockedUsers={[]}
      />
      <SuppModal show={openSuppModal} setShow={setOpenSuppModal} />
      <div className="w-full  lg:grid lg:grid-cols-8 gap-6 ">
        <div className="hidden lg:block opacity-0 "></div>
        <div className="w-full col-span-6 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-5 text-[#19295C]">
          <div className="text-[#19295C] font-bold text-base w-full text-left sm:text-lg 2xl:text-xl capitalize-first">
            {t("accountSettings")}
          </div>
          <div className="flex flex-col justify-start items-start w-full gap-4 bg-white !rounded-lg !px-6 !py-4 ">
            {/* <div className="text-base text-[#1A64B9] font-semibold ">
              Paramètres de notifications
            </div> */}
            <div className="flex justify-between items-center w-full  text-sm ">
              <span>{t("reminderNotifications")}</span>
              <label className="inline-flex items-center  cursor-pointer">
                <input
                  checked={Boolean(localSettings?.reminderNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("reminderNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="  bg-gray-200 rounded-full peer dark:bg-gray-700  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute   after:bg-white after:border-gray-300 after:border after:rounded-full  after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4  peer-focus:outline-none     peer      after:top-[1.5px] after:start-[1px]   after:h-3 after:w-3 "></div>
              </label>
            </div>
            <div className="flex justify-between items-center w-full  text-sm ">
              <span>{t("messageNotifications")}</span>
              <label className="inline-flex items-center  cursor-pointer">
                <input
                  checked={Boolean(localSettings?.messageNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("messageNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="  bg-gray-200 rounded-full peer dark:bg-gray-700  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute   after:bg-white after:border-gray-300 after:border after:rounded-full  after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4  peer-focus:outline-none     peer      after:top-[1.5px] after:start-[1px]   after:h-3 after:w-3 "></div>
              </label>
            </div>
            <div className="flex justify-between items-center w-full  text-sm ">
              <span>{t("interventionNotifications")}</span>
              <label className="inline-flex items-center  cursor-pointer">
                <input
                  checked={Boolean(localSettings?.interventionNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("interventionNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="  bg-gray-200 rounded-full peer dark:bg-gray-700  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute   after:bg-white after:border-gray-300 after:border after:rounded-full  after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4  peer-focus:outline-none     peer      after:top-[1.5px] after:start-[1px]   after:h-3 after:w-3 "></div>
              </label>
            </div>
            <div className="flex justify-between items-center w-full  text-sm ">
              <span>{t("offerNotifications")}</span>
              <label className="inline-flex items-center  cursor-pointer">
                <input
                  checked={Boolean(localSettings?.offerNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("offerNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="  bg-gray-200 rounded-full peer dark:bg-gray-700  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute   after:bg-white after:border-gray-300 after:border after:rounded-full  after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4  peer-focus:outline-none     peer      after:top-[1.5px] after:start-[1px]   after:h-3 after:w-3 "></div>
              </label>
            </div>
            <div className="flex justify-between items-center w-full  text-sm ">
              <span>{t("emailNotifications")}</span>
              <label className="inline-flex items-center  cursor-pointer">
                <input
                  checked={Boolean(localSettings?.mailNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("mailNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="  bg-gray-200 rounded-full peer dark:bg-gray-700  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute   after:bg-white after:border-gray-300 after:border after:rounded-full  after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4  peer-focus:outline-none     peer      after:top-[1.5px] after:start-[1px]   after:h-3 after:w-3 "></div>
              </label>
            </div>
            <div className="flex justify-between items-center w-full text-sm">
              <span>{t("smsNotifications")}</span>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  checked={Boolean(localSettings?.smsNotifs)}
                  type="checkbox"
                  onChange={() => handleToggle("smsNotifs")}
                  className="sr-only peer"
                  disabled={Boolean(pendingSetting)}
                />
                <div className="bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600 peer-checked:bg-[#4CAF50] relative w-7 h-4 peer-focus:outline-none after:top-[1.5px] after:start-[1px] after:h-3 after:w-3"></div>
              </label>
            </div>
            <div className="!py-2 border-b border-t w-full flex justify-between items-center">
              <span>{t("language")}</span>
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  className=" i-false !p-0 font-bold text-lg "
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={language === "en" ? enFlag : frFlag}
                      className="w-[18px] aspect-square "
                      alt={t("language")}
                    />
                    <span className="text-[#19295C] font-normal text-sm">
                      {t(language === "en" ? "English" : "French")}
                    </span>
                    <i className="fi fi-rr-angle-small-down flex items-center"></i>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleLanguageChange("en")}>
                    <div className="flex items-center gap-2">
                      <img
                        src={enFlag}
                        className="w-[18px] aspect-square "
                        alt={t("English")}
                      />
                      {t("English")}
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleLanguageChange("fr")}>
                    <div className="flex items-center gap-2">
                      <img
                        src={frFlag}
                        className="w-[18px] aspect-square "
                        alt={t("French")}
                      />
                      {t("French")}
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="!pb-2 border-b  w-full flex justify-between items-center">
              <span>{t("blockedUsers")}</span>
              <div
                onClick={() => {
                  setOpenModal(true);
                }}
                className=" text-[#1A64B9] rounded-lg underline cursor-pointer text-xs font-medium text-nowrap "
              >
                {t("viewList")}
              </div>
            </div>
            <div
              onClick={() => setOpenSuppModal(true)}
              className="flex items-center justify-start gap-2 text-red-600 cursor-pointer text-sm "
            >
              <i className="fi fi-rr-delete-user flex items-center"></i>
              <span>{t("accountDeletion")}</span>
            </div>
          </div>
        </div>

        <div className="hidden lg:block opacity-0 "></div>
      </div>
    </>
  );
};

export default AccountSettingPage;
